
import { post } from "../../helpers/http";


export const RegisterPatient = async (data) => {
    return (await post(`${process.env.REACT_APP_LAW_API_URL}PatientRegistration/register-patient`, '', data))
    // return (await post(`https://localhost:44301/api/PatientRegistration/register-patient`, '', data))
};

export const CheckPatientRegistration = async (data) => {
    return (await post(`${process.env.REACT_APP_LAW_API_URL}PatientRegistration/check-patient-registration`, '', data))
    // return (await post(`https://localhost:44301/api/PatientRegistration/check-patient-registration`, '', data))
};

export const SendPatientRegistrationOtp = async (data) => {
    return (await post(`${process.env.REACT_APP_LAW_API_URL}Patient/send-patient-registration-otp`, '', data))
    // return (await post(`https://localhost:44301/api/Patient/send-patient-registration-otp`, '', data))
};